import {
  AppBar,
  Badge,
  CardContent,
  IconButton,
  Typography
} from "@material-ui/core";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import SettingsIcon from "@material-ui/icons/Settings";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getConfig, getKyc } from "../actions";
import AbtcAvatar from "../custom/Avatar";
import { badgesKyc } from "../custom/BadgesKyc";
import HeaderPageItem from "../custom/HeaderPageItem";
import PageContainer, { CardPageItem } from "../custom/Page";
import { FormattedMessage } from "react-intl";
import SafewordDisplay from "./components/SafewordDisplay";

class BusinessDashboard extends Component {
  state = {
    pj: this.props.currentUser.isPj
  };

  loadKyc = () => {
    getKyc().then(data => {
      const userKyc = data;
      this.setState({ userKyc });
    });
  };
  componentDidMount() {
    this.loadKyc();
    getConfig();
  }
  pendent = (badges, currentUser) => {
    if (currentUser.telefone == null && currentUser.telefone2 == null) {
      badges.qtd = badges.qtd + 1;
      badges.cor = "error";
    }
    if (!currentUser.emailConfirmed) {
      badges.qtd = badges.qtd + 1;
      badges.cor = "error";
    }
    return badges;
  };

  render() {
    const { currentUser, config } = this.props;
    const { userKyc, pj } = this.state;
    let badges = badgesKyc(pj, userKyc, config.isSumsubKYCEnabled);
    badges = this.pendent(badges, currentUser);

    return (
      <PageContainer removeSpacing>
        <HeaderPageItem style={{ height: 210 }}>
          <AppBar
            position="relative"
            style={{
              height: 110,
              paddingTop: 30,
              display: "flex",
              alignItems: "center"
            }}
          >
            <SafewordDisplay safeword={currentUser.safeword} />
            <IconButton
              style={{ position: "absolute", left: 0, top: 0 }}
              component={Link}
              to="/logout"
            >
              <ExitToAppIcon
                htmlColor="#23323C"
                style={{ transform: "rotate(180deg)" }}
              />
            </IconButton>
            <IconButton
              style={{ position: "absolute", right: 0, top: 0 }}
              component={Link}
              to="/more"
            >
              <Badge badgeContent={badges.qtd} color={badges.cor}>
                <SettingsIcon htmlColor="#23323C" />
              </Badge>
            </IconButton>
            <AbtcAvatar
              imageUrl={currentUser.photoUrl}
              disableLink
              size={160}
              avatarStyle={{ border: "8px rgba(254, 193, 44, 1) solid" }}
              style={{}}
            />
          </AppBar>
        </HeaderPageItem>

        <CardPageItem>
          <CardContent>
            <Typography
              variant="h6"
              style={{ width: "100%", textAlign: "center" }}
            >
              {currentUser.name}
              <br />
              (<FormattedMessage id="app.enuns.AUDITOR" />)
            </Typography>
          </CardContent>
        </CardPageItem>
      </PageContainer>
    );
  }
}

function mapStateToProps(state) {
  return {
    config: state.config,
    currentUser: state.user.user.me
  };
}

export default connect(mapStateToProps, null)(BusinessDashboard);
